<script>

    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

</script>

<style>

    .faq-con {
        position: fixed;
        max-width: 600px;
        top: 1vh;
        left: 50%;
        max-height: 98vh; 
        transform: translate(-50%, 0%);
        border: 2px solid black;
        padding: 10px;
        background-color: white;
        /* pointer-events: auto; */
        z-index: 10000;
        box-sizing: border-box;
        overflow-y: scroll;
  
    }

    @media (max-width: 900px) {
        .faq-con {
            left: 2vw;
            width: 96vw;
            transform: unset;
            box-sizing: border-box;
        }
    }

    .faq-header {
        display: flex;
        justify-content: space-between;
    }

    .faq-title {
        font-size: 32px;
        font-weight: 700;
    }

    .faq-close {
        cursor: pointer;
    }

    .faq-body {
        
    }

    .faq-item {
        /* border-bottom: 1px solid #D9D9D9; */
    }

    .faq-q {
        font-weight: 700;
    }

</style>

<div class='faq-con'>

    <div class='faq-header'>
        <div class='faq-title'>
            FAQs 
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class='faq-close' on:click={(e) => dispatch('close-faq')}>
            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 26 26" width="26px" height="26px"><path d="M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z"/></svg>
        </div> 
    </div>

    <div class='faq-body'>

        <div class='faq-item'>
            <div class='faq-q'><p>Where is the data from?</p></div>
            <div class='faq-a'>
                <p>We've looked at the prices of property sales within one kilometre of each Tube station, using data published by the Land Registry.</p>
                <p>Specifically, the <a href="https://www.gov.uk/government/statistical-data-sets/price-paid-data-downloads">Land Registry's Price Paid Data</a>, which compiles information on all property sales in England and Wales, including the postcode of the property and the sale price. We used the most recent release of the dataset, which covers property sales up to the end of July 2024.</p>
                <p>However, the Land Registry does not collect information on the number of bedrooms in each property — so our figures represent an average across all property sizes.</p>
                <p>For each Tube station, we identified all sales of properties that lie within a kilometre of the station as the crow flies. We then calculated the median price within 12 month periods — the figures you first see when you view the map is the median price in the 12 months to July 31, 2024.</p>
                <p>We used the median because the mean can be skewed by extreme examples (and there are many of those in London...).</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>Why do some stations say 'not enough data'?</div>
            <div class='faq-a'>
                <p>For some stations there simply weren't enough property sales within a kilometre to arrive at a robust figure.</p> 
                <p>We excluded any station with fewer than 10 sales — but the overwhelming majority had more than this. On average, each Tube station's figures are based on 1,500 sales within the past five years.</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>What's the difference between 'all property prices' and 'just flat prices'?</div>
            <div class='faq-a'>
                <p>The data we've used from the Land Registry does distinguish between detached, semi-detached, terraced and flat/apartment homes.</p>
                <p>'All property prices' is the average across all of these property types, while 'just flat prices' is the average across flats/apartments.</p>
                <p>We added this extra filter because many first-time buyers in London are looking at flats.</p>
            </div>
        </div>
        <div class='faq-item'>
            <div class='faq-q'>Who are you guys?</div>
            <div class='faq-a'>
                <p>We're <i>London Spy</i>, a newsletter for Londoners publishing round-ups, features, investigations and special projects about life in the capital.</p>
                <p>We started the <i>Spy</i> because we think London's local media is in big trouble, and the city needs a new publication to bring quality back. We're reader-funded, because we think ad-based local news just isn't any good.</p>
                <p>You can <a href="https://www.thelondonspy.co.uk/">sign up the <i>Spy</i> at our website here</a>. Get in touch by emailing us at <a href="mailto:londonspy@substack.com">londonspy@substack.com</a>.</p>
            </div>
            
        </div>

    </div>

</div>